import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import SnapshotsList from '../snapshots-list';
import SnapshotAddUpdate from '../snapshot-add-update';
import { EditMode } from '../../../../data/enums';
import { useAmaV2Context } from 'context/ama-v2-provider';

export default function SnapshotsView() {

  const [editMode, setEditMode] = useState<EditMode>(EditMode.View);
  const { loadSnapshots } = useAmaV2Context();

  useEffect(() => {
    if (editMode === EditMode.View) {
      void loadSnapshots();
    }
  }, [editMode]);

  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>

      { (editMode === EditMode.View) && 
        <SnapshotsList mode={editMode} setEditMode={setEditMode}/>
      }

      { ((editMode === EditMode.Add || editMode === EditMode.Edit)) && 
        <SnapshotAddUpdate mode={editMode} setEditMode={setEditMode}/>
      }

    </Box>
  );
}

